module.exports = __webpack_public_path__ + "img/组 126@2x(6).18ad01d0.png";